export const InstrumentOwnerType = {
  Company: "company",
  Worker: "worker",
  Zeal: "zeal",
  CustomerAccount: "customer_account",
} as const;
export type InstrumentOwnerType =
  (typeof InstrumentOwnerType)[keyof typeof InstrumentOwnerType];
